

















































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { audio } from "@/config/host.config";
import { deleteElement } from "@/api/delite/delite-element";
import { AxiosError } from "axios";
import ButtonBack from "@/components/buttons/button-back.vue";
import ButtonCart from "@/components/buttons/button-cart.vue";
import InputSearch from "@/components/app/search/input-search.vue";
import StandartTable from "@/components/tables/standart-table.vue";
import PlaylistTableCard from "@/components/tables/audio/playlist-table-card.vue";

const playlistUrl = audio.songs.replace("/songs", "/id3/playlists");

interface IPlaylistSrc {
  background?: string;
  cover?: string;
  poster?: string;
  image?: string;
  icon?: { icon: string; lib: string } | string;
  svg?: string;
}

interface IPlaylist {
  _id: string;
  name: string;
  show: boolean;
  description?: string;
  createdBy: string;
  src?: IPlaylistSrc;
  createdAt: string;
  updatedAt: string;
  trackCount: number;
  tracks: Array<string>;
}

interface ISortColumn {
  name: number;
  createdAt: number;
}

@Component({
  components: {
    ButtonBack,
    ButtonCart,
    InputSearch,
    StandartTable,
    PlaylistTableCard,
  },
})
class PlaylistsPage extends Vue {
  playlistList: Array<IPlaylist> = [];
  deleted = false;
  loading = false;
  search = "";
  sortKey = "";
  sortOrder: ISortColumn = { name: 1, createdAt: -1 };
  ddOpen = false;

  get filteredList(): Array<IPlaylist> {
    const search = this.search && this.search.toLowerCase();
    const order = this.sortOrder[this.sortKey as keyof ISortColumn] || 1;

    let list = this.playlistList;

    if (search) {
      list = list.filter((item) =>
        item.name ? item.name.toLowerCase().indexOf(search) > -1 : false
      );
    }

    if (this.sortKey) {
      list = list.slice().sort((a: IPlaylist, b: IPlaylist) => {
        if (this.sortKey == "name") {
          const one = a.name.toLowerCase();
          const two = b.name.toLowerCase();
          return (one === two ? 0 : one > two ? 1 : -1) * order;
        }
        const one = a.createdAt;
        const two = b.createdAt;
        return (
          (one === two ? 0 : !one ? 1 : !two ? -1 : one > two ? 1 : -1) * order
        );
      });
    }

    return list;
  }

  sortBy(key: string): void {
    this.sortKey = key;
    this.sortOrder[key as keyof ISortColumn] =
      this.sortOrder[key as keyof ISortColumn] * -1;
  }

  async deletePlaylist(id: string): Promise<void> {
    const message = this.deleted
      ? String(this.$t("music.confirmDeletePlaylistForever"))
      : String(this.$t("music.confirmDeletePlaylist"));
    const ok = await this.$bvModal.msgBoxConfirm(message, {
      title: String(this.$i18n.t("buttons.delete")),
      okVariant: "danger",
      cancelVariant: "secondary",
    });
    if (!ok) return;

    if (this.deleted) {
      try {
        await this.$axios.delete(`${playlistUrl}/${id}/force`);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.fetchPlaylists();
      } catch (e) {
        console.log(e);
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      }
    } else {
      deleteElement(id, playlistUrl)
        .then(() => {
          this.$notify({
            group: "global",
            text: String(this.$i18n.t("error.200")),
          });
          this.fetchPlaylists();
        })
        .catch((e: AxiosError) => {
          console.log(e);
          this.$notify({
            group: "global",
            text: String(this.$i18n.t("alerts.emptyUpdate")),
            type: "warn",
          });
        });
    }
  }

  async restorePlaylist(id: string): Promise<void> {
    try {
      const res = await this.$axios.put(`${playlistUrl}/${id}/restore`);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.fetchPlaylists();
      }
    } catch (e) {
      console.log(e);
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("alerts.emptyUpdate")),
        type: "warn",
      });
    }
  }

  async toggleShow(id: string, show: boolean): Promise<void> {
    try {
      await this.$axios.put(`${playlistUrl}/${id}`, { show });
    } catch (e) {
      console.log(e);
    }
  }

  @Watch("deleted")
  async onDeletedChange(): Promise<void> {
    this.$router
      .replace({
        query: {
          ...this.$route.query,
          deleted: this.deleted ? "true" : undefined,
        },
      })
      .catch(() => undefined);
    await this.fetchPlaylists();
  }

  async fetchPlaylists(): Promise<void> {
    this.loading = true;
    try {
      const params = { "match[deleted][value]": this.deleted };
      const res = await this.$axios.get(playlistUrl, { params });
      if (res.status === 200) {
        this.playlistList = res.data;
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  mounted(): void {
    this.deleted = this.$route.query.deleted === "true";
    this.fetchPlaylists();
  }
}
export default PlaylistsPage;
